import TacheFormController from './tache.form.controller';

export default {
    template: require('./tache.form.html'),
    controller: TacheFormController
};
